<template>
  <div class="upload-container">
    <h1>Upload File to Google Drive</h1>
   
    <!-- Google Login Button -->
    <button @click="loginWithGoogle" class="google-login-button" >
      Log in with Google
    </button>
    <p v-if="isLoginSuccess">Login successfull</p>
 
    <!-- File Input and Upload -->
    <div >
      <div class="file-input-container">
        <input type="file" @change="handleFileChange" id="file-input" />
        <label for="file-input" class="file-label">
          {{ selectedFile ? selectedFile.name : 'Choose a file' }}
        </label>
      </div>
     
      <button
        @click="uploadToGoogleDrive"
        :disabled="!selectedFile || isUploading"
        class="upload-button"
      >
        {{ isUploading ? 'Uploading...' : 'Upload to Google Drive' }}
      </button>
     
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
     
      <div v-if="uploadedFileLink" class="success-message">
        File uploaded successfully!
        <a :href="uploadedFileLink" target="_blank">View in Google Drive</a>
      </div>
    </div>
  </div>
</template>
 
<script lang="ts">
import { defineComponent } from "vue";
import { toast } from "@/main";
import { mapGetters } from "vuex";
 
export default defineComponent({
  name: "GoogleDriveUploader",
 
  data() :any{
    return {
      selectedFile: null as File | null,
      isUploading: false,
      errorMessage: "",
      uploadedFileLink: "",
      isAuthenticated: false,  // Flag to track if user is authenticated
      isLoginSuccess:false
    };
  },
   computed: {
    ...mapGetters({ userInfo: "userInfo" }),
  },
 
  mounted() {
    // Check if the user is already authenticated when the component mounts
   // this.checkAuthenticationStatus();
   
  if (Object.keys(this.$route.query).includes('success') && this.$route.query.success === 'true') {
    this.isLoginSuccess = true;
  } else {
    this.isLoginSuccess = false;
  }

   
   
  },
 
  methods: {
   
loginWithGoogle() {
   
  window.location.href = `${process.env.VUE_APP_INTEGRATIONS_API}/api/google/drive?prompt=select_account&clientId=${this.userInfo.domainId}&clientName=${this.userInfo.domainName}&userId=${this.userInfo._id}
`;
},
 
//   loginWithGoogle() {
//   const url = `${process.env.VUE_APP_INTEGRATIONS_API_URL}/api/google/drive?prompt=select_account`;
//   window.open(url, '_blank');
// },
    handleFileChange(event: Event) {
      const target = event.target as HTMLInputElement;
      const file = target.files?.[0];
      if (file) {
        this.selectedFile = file;
        this.errorMessage = "";
      }
    },
   
    async uploadToGoogleDrive() {
      // Validate file selection
      if (!this.selectedFile) {
        this.errorMessage = "Please select a file first";
        toast.error(this.errorMessage);
        return;
      }
     
      this.isUploading = true;
      this.errorMessage = "";
     
      try {
        // Convert file to base64
        const base64Data = await this.fileToBase64(this.selectedFile);
        const base64Content = base64Data.split(',')[1];
 
        // Prepare the payload
        const payload = {
          base64: base64Content,
          filename: this.selectedFile.name,
          mimetype: this.selectedFile.type
        };
 
        // Make the API request to upload to Google Drive
        const response =  await this.$http.post(
  `${process.env.VUE_APP_INTEGRATIONS_API}/api/google/drive/upload?clientId=${this.userInfo.domainId}&clientName=${this.userInfo.domainName}&userId=${this.userInfo._id}`,
  payload
);
 
 
        // Handle success
        if (response.data && response.data.link) {
          this.uploadedFileLink = response.data.link;
          toast.success("File uploaded successfully to Google Drive");
        } else {
          throw new Error("No file link returned from the server");
        }
      } catch (error) {
        this.errorMessage = error instanceof Error
          ? `Upload failed: ${error.message}`
          : "Upload failed due to an unknown error";
        toast.error(this.errorMessage);
      } finally {
        this.isUploading = false;
      }
    },
 
    fileToBase64(file: File): Promise<string> {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = error => reject(error);
      });
    }
  }
});
</script>
 
<style scoped>
.upload-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
}
 
.google-login-button {
  padding: 10px 20px;
  background-color: #db4437;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
 
.file-input-container {
  margin: 20px 0;
  position: relative;
}
 
#file-input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}
 
.file-label {
  display: block;
  padding: 10px 15px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
 
.upload-button {
  display: block;
  width: 100%;
  padding: 10px;
  background: #4f46e5;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}
 
.upload-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}
 
.error-message {
  color: #ef4444;
  margin-top: 10px;
}
 
.success-message {
  color: #10b981;
  margin-top: 10px;
}
 
.success-message a {
  color: #4f46e5;
  text-decoration: underline;
}
</style>